import { render, staticRenderFns } from "./interview_evaluation.vue?vue&type=template&id=2dd24ce0&scoped=true&"
import script from "./interview_evaluation.vue?vue&type=script&lang=js&"
export * from "./interview_evaluation.vue?vue&type=script&lang=js&"
import style0 from "./interview_evaluation.vue?vue&type=style&index=0&id=2dd24ce0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd24ce0",
  null
  
)

export default component.exports